import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      {/* Header Section */}
      <section className="about-header">
        <div className="container">
          <h1>About <span className="highlight">Barn Bots</span></h1>
          <p>Having fun, building robots, learning to code, in a barn</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission">
        <div className="container">
          <div className="mission-content">
            <div className="mission-text">
              <h2>About the Team</h2>
              <p>
                Barn Bots is a new robotics and coding team for children in grades 2-5, located in Hampton Falls, NH at Miracle Farm. 
              </p>
              <p>
                We are a registered <a href="https://www.vexrobotics.com/go" className="standout-link">Vex Robotics</a> team working to complete four expeditions:
                <ul>
                  <li>
                    <a href="https://education.vex.com/stemlabs/go/ocean-science-exploration" className="standout-link">
                      Ocean Science Exploration
                    </a>
                    <img 
                      src='https://education.vex.com/stemlabs/sites/default/files/2024-11/Ocean%20Science-Lab5-Unit%20Tile_0.png' 
                      alt="Ocean Science Exploration"
                      className="expedition-image"
                    />
                  </li>
                  <li>
                    <a href="https://education.vex.com/stemlabs/go/mars-math-expedition" className="standout-link">
                      Mars Math Expedition
                    </a>
                    <img 
                      src='https://education.vex.com/stemlabs/sites/default/files/2024-11/Mars%20Math%20Lab5-Unit%20Tile_0.png' 
                      alt="Mars Math Expedition"
                      className="expedition-image"
                    />
                  </li>
                  <li>
                    <a href="https://education.vex.com/stemlabs/go/city-technology-rebuild" className="standout-link">
                      City Technology Rebuild
                    </a>
                    <img 
                      src='https://education.vex.com/stemlabs/sites/default/files/2024-11/City%20Technology-Lab5-Unit%20Tile.png' 
                      alt="City Technology Rebuild"
                      className="expedition-image"
                    />
                  </li>
                  <li>
                    <a href="https://education.vex.com/stemlabs/go/village-engineering-construction" className="standout-link">
                      Village Engineering Construction
                    </a>
                    <img 
                      src='https://education.vex.com/stemlabs/sites/default/files/2024-11/Village%20Engineering-Lab5-Unit%20Tile_0.png' 
                      alt="Village Engineering Construction"
                      className="expedition-image"
                    />
                  </li>
                </ul>
              </p>
            </div>
            <div className="mission-image">
              <img src="/barn-bots-logo.jpg" alt="Barn Bots Mission" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
